import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { TextField } from '@material-ui/core';
import { Search, Clear, BorderRight } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useTranslation } from 'react-i18next';
import * as actions from '../../../../store/index';

const useStyles = makeStyles((theme) => ({
  SearchBar: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    '& .MuiOutlinedInput-input:-webkit-autofill': {
      WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.mainDark} inset`,
      borderRadius: 'initial',
    },
  },

  textField: {
    margin: '0 4px',
    width: '100%',
    border: 'none !important',
    '&.MuiInput-underline': {
      borderBottom: 'none !important',
    },
    '& .MuiInputBase-input::placeholder': {
      fontSize: '12px',
      color: theme.palette.text.secondary,
    },
    '& .MuiOutlinedInput-root': {
      height: '30px',
      padding: '2px',
    },
    '& .MuiInputBase-input': {
      padding: '0',
    },
  },
}));

function SearchBar(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // Store state
  const filterPrompt = useSelector((state) => state.filter.search);

  // local state
  const [localPrompt, setLocalPrompt] = useState('');
  const [typingTimeout, setTypingTimeout] = useState(null);

  // Effects
  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(() => {
      dispatch(actions.setFilterProperty(['search', localPrompt || null]));
    }, 800);

    setTypingTimeout(timeout);
  }, [localPrompt]);

  useEffect(() => {
    if (filterPrompt !== localPrompt) {
      setLocalPrompt(filterPrompt || '');
    }
  }, [filterPrompt]);

  return (
    <div className={[classes.SearchBar, props.className].join(' ')}>
      <TextField
        size='small'
        id='search-examinations'
        placeholder={t('DatePicker.search_patient')}
        className={classes.textField}
        value={localPrompt}
        onChange={(event) => setLocalPrompt(event.target.value)}
        variant='outlined'
        autoComplete='off'
        InputProps={{
          style: {
            paddingRight: '4px',
            paddingLeft: '4px',
          },
          startAdornment: (
            <InputAdornment position='start'>
              <Search fontSize='small' />
            </InputAdornment>
          ),
          endAdornment: (
            <>
              <InputAdornment style={{ cursor: 'pointer' }} position='end' onClick={() => setLocalPrompt('')}>
                {localPrompt && <Clear fontSize='small' />}
              </InputAdornment>
            </>
          ),
        }}
      />
    </div>
  );
}

export default SearchBar;
